import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { UploadFile } from '@mui/icons-material';

interface SwiftFlowErrorsHeaderProps {
    isFetching: boolean;
    isCreating: boolean;
    onNewError: () => void;
    onBulkUpload: () => void;
}

export function SwiftFlowErrorsHeader({
    isFetching,
    isCreating,
    onNewError,
    onBulkUpload,
}: SwiftFlowErrorsHeaderProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 3,
            }}
        >
            <Typography variant="h5" component="h1">
                Swift Flow Errors
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Button
                    variant="contained"
                    size="small"
                    onClick={onNewError}
                    disabled={isCreating}
                >
                    New Error
                </Button>
                <Button
                    variant="outlined"
                    size="small"
                    startIcon={<UploadFile />}
                    onClick={onBulkUpload}
                >
                    Bulk Upload CSV
                </Button>
                {isFetching && <CircularProgress size={20} />}
            </Box>
        </Box>
    );
}
